export const isArcGisWmsLayer = layer =>
  layer.metadata &&
  layer.metadata.serverType &&
  layer.metadata.serverType.toLowerCase() === 'arcgis'

export const isArcGisWfsLayer = layer =>
  layer.metadata &&
  layer.metadata.serverType &&
  layer.metadata.serverType.toLowerCase() === 'arcgiswfs'

export const isArcGisLayer = layer => isArcGisWfsLayer(layer) || isArcGisWmsLayer(layer)

export default isArcGisLayer 
